import { render, staticRenderFns } from "./selectContentSingle.vue?vue&type=template&id=f66688e0"
import script from "./selectContentSingle.vue?vue&type=script&lang=js"
export * from "./selectContentSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports